export const PENALTY_EXCEPTIONS_TYPES = {
    CALL_IN: "CALL_IN",
    SPLIT_SHIFT: "SPLIT_SHIFT"
}

export const PENALTY_EXCEPTIONS_STATUSES = {
    IGNORED: "IGNORED",
    SYSTEM_IGNORED: "SYSTEM_IGNORED",
    SYSTEM_APPROVED: "SYSTEM_APPROVED",
    APPROVED: "APPROVED",
    PENDING_APPROVAL: "PENDING_APPROVAL",
}